module.exports = __webpack_public_path__ + "static/media/ios_class_for_beginners.2002cc1f.jpg";